import React, { useState } from 'react';
import classNames from 'classnames';
import Avatar from './avatar';
import { ShotFeed } from '../../stores/reducers/shots';

interface Props {
	invites: any,
	size: string,
	alignEnd: boolean,
	expandable?: boolean,
	classnames?: string;
	maxBubbles?: number,
}

export default function AvatarBubbleRow(props: Props) {
	const {
		invites,
		size = 'thirtytwo',
		alignEnd,
		expandable = false,
		classnames,
		maxBubbles = 3,
	} = props;
	const [showAll, setShowAll] = useState(false);
	const [hideShowAll, setHideShowAll] = useState(false);

	function hide() {
		setHideShowAll(true);
		setTimeout(() => {
			setShowAll(false);
			setHideShowAll(false);
		}, 300);
	}

	function show() {
		if (expandable) setShowAll(true);
	}

	// find out if invites is array of items with audioOnly attribute
	// let audioOnly = invites && invites.length > 0 && invites[0].audioOnly !== undefined;
	return (
		<div className={classNames('avatar-bubble-row', alignEnd, { 'show-all': showAll }, classnames)} onMouseLeave={hide} data-testid="avatar-bubble-row">
			{invites && invites.map((presenter: any, index: number): JSX.Element | null => {
				if (index < maxBubbles || invites.length === maxBubbles) {
					return (
						<div key={index} className="avatar-container">
							<Avatar
								user={presenter}
								noBorder={false}
								size={size}
							/>
						</div>
					);
				}
				return null;
			})}
			{invites && invites.length > maxBubbles && invites.length !== maxBubbles && (
				<div className="avatar-container" onClick={show}>
					<div className={classNames('avatar-placeholder', size)} data-testid="avatar-placeholder">
						+{invites.length - maxBubbles}
					</div>
				</div>
			)}
			{showAll && (
				<div className={classNames('show-all-container', { hiding: hideShowAll })}>
					{invites && invites.map((presenter: any, index: number): JSX.Element | undefined => (
							<div key={index} className="avatar-container">
								<Avatar
									user={presenter}
									noBorder={true}
									size={size}
								/>
							</div>
					))}
				</div>
			)}
		</div>
	);
}
